import { render, staticRenderFns } from "./FormRoute.vue?vue&type=template&id=10b3d978&"
import script from "./FormRoute.vue?vue&type=script&lang=js&"
export * from "./FormRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b3d978')) {
      api.createRecord('10b3d978', component.options)
    } else {
      api.reload('10b3d978', component.options)
    }
    module.hot.accept("./FormRoute.vue?vue&type=template&id=10b3d978&", function () {
      api.rerender('10b3d978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/route/form/FormRoute.vue"
export default component.exports